import wait from '../lib/wait'
import { sections } from '../lib/get-sections'

import NavigationService from './navigation'
import { updateDecisionsAndState, updateSelectedBusiness } from '../redux/businesses'
import { v4 as uuidv4 } from '../lib/uuid'

const getRandomNumberBetween = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

export default class Automator {
  constructor (store) {
    this.store = store
    this.workingScreen = false
    this.intervalScreen = 0
    this.workingWidgets = false
    this.menuTimeMax = 0
    this.menuTimeMin = 0
    this.widgetTimeMin = 0
    this.widgetTimeMax = 0
    this.intervalWidgets = 0
  }

  start ({ testModeScreen, menuTimeMax, menuTimeMin, testModeWidgets, widgetTimeMin, widgetTimeMax, widgetIndex = 0 } = {}) {
    if (!testModeScreen && !testModeWidgets) {
      this.workingScreen = false
      this.menuTimeMax = 0
      this.menuTimeMin = 0
      this.workingWidgets = false
      this.widgetTimeMin = 0
      this.widgetTimeMax = 0
      this.intervalScreen = 0
      this.intervalWidgets = 0
      return
    }

    if (testModeScreen && !this.workingScreen) {
      this.workingScreen = true
      this.workingWidgets = false
      this.widgetTimeMin = 0
      this.widgetTimeMax = 0

      this.menuTimeMax = menuTimeMax
      this.menuTimeMin = menuTimeMin
      this.intervalScreen = getRandomNumberBetween(menuTimeMin, menuTimeMax)
      this.automateScreen()
      return
    }

    if (testModeScreen && (this.menuTimeMin !== menuTimeMin || this.menuTimeMax !== menuTimeMax)) {
      this.menuTimeMax = menuTimeMax
      this.menuTimeMin = menuTimeMin
      this.intervalScreen = getRandomNumberBetween(menuTimeMin, menuTimeMax)
      return
    }

    if (testModeWidgets && !this.workingWidgets) {
      this.workingWidgets = true
      this.workingScreen = false
      this.menuTimeMax = 0
      this.menuTimeMin = 0

      this.widgetTimeMin = widgetTimeMin
      this.widgetTimeMax = widgetTimeMax
      this.intervalWidgets = getRandomNumberBetween(widgetTimeMin, widgetTimeMax)
      this.widgetIndex = widgetIndex
      this.automateWidgets()
      return
    }

    if (testModeWidgets && (this.widgetTimeMin !== widgetTimeMin || this.widgetTimeMax !== widgetTimeMax)) {
      this.widgetTimeMin = widgetTimeMin
      this.widgetTimeMax = widgetTimeMax
      this.intervalWidgets = getRandomNumberBetween(widgetTimeMin, widgetTimeMax)
    }
  }

  automateScreen = async () => {
    const { game: gameState, device: deviceState, ui: uiState, team: teamState } = this.store.getState()

    if (this.workingScreen) {
      if (deviceState.registered && teamState.id && teamState.registered) {
        // do stuff
        const currentRound = gameState.currentRound
        const currentRoundSetup = gameState.currentRoundSetup
        const selectedRound = gameState.selectedRound
        const roundsSetup = gameState.roundsSetup
        const isWrapUp = gameState.state === 'wrapup'

        let roundSetup = currentRoundSetup
        if (selectedRound !== currentRound) {
          roundSetup = roundsSetup.find(rs => rs.round === selectedRound)
        }
        const activeSections = sections(roundSetup, isWrapUp)

        const allSections = activeSections.reduce((acc, as) => {
          return acc.concat(as.items)
        }, []).filter(i => i.id !== uiState.currentTab)

        const randomIndex = getRandomNumberBetween(0, allSections.length - 1)
        const randomSection = allSections[randomIndex]

        NavigationService.navigate(randomSection.id)
      }
      await wait(this.intervalScreen * 1000)
      this.automateScreen()
    }
  }

  automateWidgets = async () => {
    const { game: gameState, device: deviceState, ui: uiState, team: teamState, businesses: businessState } = this.store.getState()

    if (this.workingWidgets) {
      if (deviceState.registered && teamState.id && teamState.registered) {
        if (uiState.currentTab !== 'Businesses') {
          NavigationService.navigate('Businesses')
        }

        if (businessState.isLoaded) {
          const selectedRound = gameState.selectedRound
          const businessToChange = businessState.businesses[this.widgetIndex]

          if (businessToChange) {
            if (businessState.selectedBusiness === businessToChange.type) {
              this.store.dispatch(updateDecisionsAndState({
                team: teamState.id,
                round: selectedRound,
                businessId: businessToChange.id,
                decisions: [{
                  businessId: businessToChange.id,
                  price1Now: getRandomNumberBetween(businessToChange.slider1Min, businessToChange.slider1Max)
                }, {
                  businessId: businessToChange.id,
                  price2Now: getRandomNumberBetween(businessToChange.slider2Min, businessToChange.slider2Max)
                }],
                deviceId: uuidv4()
              }))
            } else {
              this.store.dispatch(updateSelectedBusiness(businessToChange.type))
            }
          }
        }
      }
      await wait(this.intervalWidgets * 1000)
      this.automateWidgets()
    }
  }
}
